module.exports = __webpack_public_path__ + "img/info-icon.6161c743.svg";